import Vue from "vue";
import Vuetify, {
  VApp,
  VToolbar,
  VCard,
  VBtn,
  VIcon,
  VProgressCircular,
  VList,
  VAvatar,
  VListGroup,
  VOverlay,
  VDialog,
  VItemGroup,
  VListItemGroup,
  VSelect,
  VMenu,
  VContainer,
  VRow,
  VCol
} from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VApp,
    VToolbar,
    VCard,
    VBtn,
    VProgressCircular,
    VList,
    VListGroup,
    VAvatar,
    VIcon,
    VOverlay,
    VDialog,
    VItemGroup,
    VListItemGroup,
    VSelect,
    VMenu,
    VContainer,
    VRow,
    VCol
  }
});

export default new Vuetify({});
